// src/store/modules/wallpapers.js
import axios from '@/plugins/axios';

const DEFAULT_BACKGROUND_URL = 'https://picture.itmingchen.cn/i/2025/02/17/67b2e36d65a97.jpg';

const state = {
    backgroundUrl: localStorage.getItem('backgroundUrl') || DEFAULT_BACKGROUND_URL,
};

const getters = {
    /**
     * 获取当前的背景图片 URL
     * @param {Object} state - Vuex 状态对象
     * @returns {String} 当前背景图片的 URL
     */
    backgroundUrl: (state) => state.backgroundUrl,
};

const actions = {

        async fetchUserWallpapers({ commit }){
        try {
            const response = await axios.get('/admin/wallpapers/getUserWallpapers');
            console.log('API Response (fetchUserWallpapers):', response);
            // 根据实际 API 返回的数据结构调整访问路径
            if (response && response.code === 200) {
                const uploadedUrl = response.data.path;
                console.log(uploadedUrl)
                commit('SET_BACKGROUND_URL', uploadedUrl);
            } else {
                console.error('API 返回的数据结构不正确:', response);
            }
        } catch (error) {
            console.error('获取用户背景失败:', error);
            throw error;
        }
    },
    /**
     * 设置新的背景图片 URL
     * @param {Object} context - Vuex 上下文对象
     * @param {String} url - 新的背景图片 URL
     */
    setBackgroundUrl({ commit }, url) {
        commit('SET_BACKGROUND_URL', url);
    },

    /**
     * 重置背景图片 URL 为默认值
     * @param {Object} context - Vuex 上下文对象
     */
    resetBackgroundUrl({ commit }) {
        commit('SET_BACKGROUND_URL', DEFAULT_BACKGROUND_URL);
    },

    /**
     * 上传壁纸图片
     * @param {Object} context - Vuex 上下文对象
     * @param {File} file - 用户选择的图片文件
     * @returns {Promise<String>} - 返回上传后的图片 URL
     */
    async uploadWallpaper({ commit }, file) {
        try {
            const formData = new FormData();
            formData.append('fileData', file);

            console.log(file)
            const response = await axios.post('/admin/wallpapers/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response && response.data) {
                const uploadedUrl = response.data;
                console.log(uploadedUrl)
                commit('SET_BACKGROUND_URL', uploadedUrl);
                return uploadedUrl;
            } else {
                throw new Error(response.data.message || '上传失败11');
            }
        } catch (error) {
            console.error('上传壁纸失败:', error);
            throw error;
        }
    },
};

const mutations = {
    /**
     * 更新背景图片 URL 并持久化到 localStorage
     * @param {Object} state - Vuex 状态对象
     * @param {String} url - 新的背景图片 URL
     */
    SET_BACKGROUND_URL(state, url) {
        state.backgroundUrl = url;
        localStorage.setItem('backgroundUrl', url);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
